export default __webpack_public_path__ + "static/media/ubr2.1dfd8750.jpeg";